<template>
  <div class="network_chart section">
    <network
      ref="network"
      :nodes="network"
      :edges="edges"
      :options="options"
      style="width: 100% !important"
    >
    </network>
  </div>
</template>

<script>
// @ is an alias to /src
import { Network } from "vue-vis-network";
import { mapState } from "vuex";
export default {
  name: "network_chart",
  components: { Network },
  data() {
    return {
      options: {
        height: "600",
        width: "100%",
        nodes: {
          borderWidth: 4,
        },
        edges: {
          color: "lightgray",
        },
      },
    };
  },
  methods: {},
  computed: {
    ...mapState({
      network: (state) => {
        return state.dashboardModule.network;
      },
      edges: (state) => {
        return state.dashboardModule.edges;
      },
      community_count: (state) => {
        return state.dashboardModule.community_count;
      },
    }),
  },
};
</script>
<style lang="scss">
.network_chart {
  margin-right: 5%;
}
</style>
